import { AppModule } from '@core/modules/app/app.module'
import { useCustomTheme } from '@/core/theme'
import { InlineScanIndicator } from '@/ui/components/inline-scan-indicator'
import Typography from '@/ui/components/typography'
import { SecurityStatusCard, TitleRow } from './SecurityStatus.styles'
import { Overview } from '../Overview'

const SecurityStatus = () => {
    const theme = useCustomTheme()
    const { scanInProgress } = AppModule.useStore()

    return (
        <SecurityStatusCard>
            <TitleRow>
                <Typography variant="m-regular" color={theme.colors.greys[900]}>
                    Security Status
                </Typography>
                <InlineScanIndicator scanInProgress={!!scanInProgress} />
            </TitleRow>
            <Overview />
        </SecurityStatusCard>
    )
}

export default SecurityStatus
